import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=32ce3915&"
import script from "./Tickets.vue?vue&type=script&lang=js&"
export * from "./Tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tickets.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
